import axios from 'axios';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL;

// Create axios instance with base URL
const apiClient = axios.create({
  baseURL: API,
  timeout: 30000,
});

// Helper to detect language from path (must check for '/' suffix to avoid matching '/destinations' as '/de')
const getLanguageFromPath = (pathname) => {
  if (pathname.startsWith('/en/') || pathname === '/en') return 'en';
  if (pathname.startsWith('/de/') || pathname === '/de') return 'de';
  return 'bg';
};

// Response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    
    if (status === 429) {
      // Rate limit exceeded
      const lang = getLanguageFromPath(window.location.pathname);
      const messages = {
        en: 'Too many requests. Please wait a moment.',
        de: 'Zu viele Anfragen. Bitte warten Sie einen Moment.',
        bg: 'Твърде много заявки. Моля изчакайте.'
      };
      
      toast.error(messages[lang], {
        duration: 3000,
      });
      
      // Redirect to 429 page after toast
      setTimeout(() => {
        const paths = { en: '/en/429', de: '/de/429', bg: '/429' };
        window.location.href = paths[lang];
      }, 2000);
    }
    
    return Promise.reject(error);
  }
);

export { apiClient, API };
export default apiClient;
